var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "M42.15 78a53.923 53.923 0 0 1 54.225-54c29.7.225 53.475 24.9 53.475 54.675V84c0 26.85 5.625 42.45 10.575 51a5.996 5.996 0 0 1 .006 5.991A6.003 6.003 0 0 1 155.25 144H36.75a6.004 6.004 0 0 1-5.18-3.009 6.002 6.002 0 0 1 .005-5.991c4.95-8.55 10.575-24.15 10.575-51v-6Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M42.15 78a53.923 53.923 0 0 1 54.225-54c29.7.225 53.475 24.9 53.475 54.675V84c0 26.85 5.625 42.45 10.575 51a5.996 5.996 0 0 1 .006 5.991A6.003 6.003 0 0 1 155.25 144H36.75a6.004 6.004 0 0 1-5.18-3.009 6.002 6.002 0 0 1 .005-5.991c4.95-8.55 10.575-24.15 10.575-51v-6ZM72 144v6a24.002 24.002 0 0 0 40.971 16.971A24.005 24.005 0 0 0 120 150v-6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.e4ba923cf1ae20786cc84779028d770d.svg";
export { ForwardRef as ReactComponent };